module.exports = __webpack_public_path__ + "img/calendar2-plus-fill.f05ef4ba.svg";